import React, { useState, useMemo } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  gridFilteredSortedRowIdsSelector,
  useGridApiContext,
} from "@mui/x-data-grid";
import { withTurkishStringFilters } from "shared/util/datagrid";

const List = ({ name, items, columns, onItemSelect, isVisible = true, getRowClassName: getRowClassNameProp }) => {
  const visibilityJSON = localStorage.getItem(`${name}_visibility`);
  const savedVisibilityModel = visibilityJSON ? JSON.parse(visibilityJSON) : {};

  // Build initial visibility model: use column hide settings for fields not in localStorage
  const initialVisibilityModel = {};
  columns.forEach((col) => {
    if (col.hide !== undefined && savedVisibilityModel[col.field] === undefined) {
      initialVisibilityModel[col.field] = !col.hide;
    }
  });
  const visibilityModel = { ...initialVisibilityModel, ...savedVisibilityModel };

  const [columnVisibilityModel, setColumnVisibilityModel] = useState(visibilityModel);

  const filterJSON = localStorage.getItem(`${name}_filter`);
  const initialFilterModel = filterJSON ? JSON.parse(filterJSON) : { items: [] };
  const [filterModel, setFilterModel] = useState(initialFilterModel);

  // Need version 7
  // const [density, setDensity] = useState(localStorage.getItem(`${name}_density`) || "compact");

  const initPageSize = parseInt(localStorage.getItem(`${name}_pageSize`) || 100) || 100;
  const [pageSize, setPageSize] = useState(initPageSize);

  const OnSelectionChangeHandler = (event) => {
    onItemSelect(event[0]);
  };

  function CustomToolbar() {
    const apiRef = useGridApiContext();
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          button: {
            fontSize: "14px",
            // fontWeight: "bold",
            textTransform: "none",
            // color: "var(--color-primary-surface)",
            // "&:hover": {
            //   backgroundColor: "#f0f0f0",
            // },
          },
        }}
      >
        <div>
          <GridToolbarFilterButton />
        </div>
        <div style={{ display: "flex", gap: "20px", marginRight: "20px" }}>
          <GridToolbarColumnsButton />
          <GridToolbarDensitySelector />
          <GridToolbarExport
            csvOptions={{
              utf8WithBom: true,
              // 🔽 Seçili satırları değil, **görünen (filtrelenmiş + sıralanmış)** satırların tümünü export et
              getRowsToExport: () => gridFilteredSortedRowIdsSelector(apiRef),
            }}
            printOptions={{
              disableToolbarButton: true,
            }}
          />
        </div>
      </GridToolbarContainer>
    );
  }

  const stableItems = useMemo(() => items, [items]);
  const gridColumns = useMemo(() => withTurkishStringFilters(columns), [columns]);

  return (
    <div style={{ height: "100%", flex: 1 }}>
      <DataGrid
        sx={{
          borderRadius: 0,
          fontSize: "14px", // Genel font boyutu
          ".MuiDataGrid-columnHeaders": {
            fontSize: "15px",
            fontWeight: 600,
          },
          ".MuiDataGrid-cell": {
            fontSize: "14px",
            whiteSpace: "nowrap",
            overflow: "hidden", // Hide overflowing text
            textOverflow: "ellipsis", // Show ellipsis (...) for long text
            lineHeight: "normal",
          },

          ".MuiDataGrid-row": {
            minHeight: "40px !important",
            "&:hover": {
              backgroundColor: "#e0e0e0", // Hover rengi
            },
            "&.Mui-selected": {
              position: "relative",
              backgroundColor: "#e8f0fe !important",

              "&::before": {
                content: "''",
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                width: "4px",
                backgroundColor: "var(--color-primary-surface)",
              },
            },
          },
        }}
        rowBuffer={17}
        columnBuffer={4}
        getRowHeight={() => (isVisible ? "auto" : undefined)}
        rowHeight={isVisible ? undefined : 60}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={(newModel) => {
          localStorage.setItem(`${name}_visibility`, JSON.stringify(newModel));
          setColumnVisibilityModel(newModel);
        }}
        filterModel={filterModel}
        onFilterModelChange={(newModel) => {
          localStorage.setItem(`${name}_filter`, JSON.stringify(newModel));
          setFilterModel(newModel);
        }}
        density="compact"
        // density={density}
        // onDensityChange={(newDensity) => {
        //   localStorage.setItem(`${name}_density`, newDensity);
        //   setDensity(newDensity);
        // }}
        //pageSize={pageSize}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => {
          let pageSizeToSet = newPageSize;
          if (!newPageSize || (newPageSize !== 25 && newPageSize !== 50 && newPageSize !== 100)) {
            pageSizeToSet = 100;
          }
          localStorage.setItem(`${name}_pageSize`, pageSizeToSet);
          setPageSize(pageSizeToSet);
        }}
        key={stableItems}
        components={{
          Toolbar: CustomToolbar,
        }}
        rows={items}
        columns={gridColumns}
        getRowId={(r) => r.id}
        onSelectionModelChange={OnSelectionChangeHandler}
        getRowClassName={
          getRowClassNameProp ||
          ((params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"))
        }
      />
    </div>
  );
};

export default List;
